module.exports = __webpack_public_path__ + "img/goods11-4.ec692735.jpg";